var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7C13 10.3137 10.3137 13 7 13C6.2019 13 5.4402 12.8442 4.74366 12.5613C4.61035 12.5072 4.54369 12.4801 4.48981 12.468C4.43711 12.4562 4.3981 12.4519 4.34409 12.4519C4.28887 12.4519 4.22872 12.4619 4.10843 12.4819L1.73651 12.8772C1.48812 12.9186 1.36393 12.9393 1.27412 12.9008C1.19552 12.8671 1.13289 12.8045 1.09917 12.7259C1.06065 12.6361 1.08135 12.5119 1.12275 12.2635L1.51807 9.89157C1.53812 9.77128 1.54814 9.71113 1.54814 9.65591C1.54813 9.6019 1.54381 9.56289 1.532 9.51019C1.51992 9.45631 1.49285 9.38965 1.43871 9.25634C1.15582 8.5598 1 7.7981 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z",
    fill: "#FCEFBF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.33333 5.33333H7M4.33333 7.66667H9M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 7.7981 1.15582 8.5598 1.43871 9.25634C1.49285 9.38965 1.51992 9.45631 1.532 9.51019C1.54381 9.56289 1.54813 9.6019 1.54814 9.65591C1.54814 9.71113 1.53812 9.77128 1.51807 9.89157L1.12275 12.2635C1.08135 12.5119 1.06065 12.6361 1.09917 12.7259C1.13289 12.8045 1.19552 12.8671 1.27412 12.9008C1.36393 12.9393 1.48812 12.9186 1.73651 12.8772L4.10843 12.4819C4.22872 12.4619 4.28887 12.4519 4.34409 12.4519C4.3981 12.4519 4.43711 12.4562 4.48981 12.468C4.54369 12.4801 4.61035 12.5072 4.74366 12.5613C5.4402 12.8442 6.2019 13 7 13Z",
    stroke: "#F8D144",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.ed76247b.svg";
export { ForwardRef as ReactComponent };